<template>
    <div class="about-rp">
        <h3 class="indent">Colata</h3>
        <p class="indent">Per coprire le esigenze della propria produzione di laminati, Alcomet dispone di 6 linee di colata continua con una capacità produttiva totale di 65.000 tonnellate all'anno. L'attenzione principale è rivolta alle leghe delle serie 1xxx, 8xxx e 3xxx adatte alla maggior parte dei prodotti in foglio disponibili sul mercato, oltre che a molti tipi di lamiere e nastri per applicazioni industriali.</p>
        <p class="indent">La composizione chimica è conforme agli standard internazionali, come la EN 573-3, o agli standard interni sviluppati appositamente per garantire la migliore qualità possibile del prodotto finale.</p>
        <div class="about-rp-table">
          <div class="about-rp-table-row">
            <span>Spessore nastro:</span>
            <span>5 - 10 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Larghezza nastro:</span>
            <span>max. 1570 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Leghe disponibili:</span>
            <span>1xxx, 3xxx, 8xxx series</span>
          </div>
        </div>
        <img class="about-rp-img" src="/static/img/about/rp/1.jpg" alt="Rolling">
        <h3 class="indent">Laminazione</h3>
        <p class="indent">La divisione di produzione principale in Alcomet è rappresentata dall’impianto di laminazione, dotato di un laminatoio a freddo, uno sbozzatore e tre laminatoi finitori con una capacità totale di 50.000 tonnellate all’anno. I macchinari all’avanguardia per il taglio longitudinale, lo sgrassaggio, il taglio in lunghezza e la goffratura consente ad Alcomet di produrre un’ampia gamma di prodotti con una gran varietà di applicazioni nel foglio per imballaggio, costruzioni, automotive, scambiatori di calore, ecc.</p>
        <p class="indent">Il prodotto principale dell'azienda è il foglio per uso domestico con una produzione annua di oltre 7.000 tonnellate, il che fa di Alcomet uno dei principali fornitori europei di questo prodotto</p>
        <img class="about-rp-img" src="/static/img/about/rp/2.jpg" alt="Rolling">
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-rp {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-rp > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp-table {
  margin: 15px 0;
  width: 60%;
}
.about-rp-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-rp-table-row > span {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-rp-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .about-rp p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-rp-table,
  .about-rp > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-rp-img {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 600px) {
  .about-rp-table-row > span {
    font-size: 12px;
  }
  .about-rp-table-row > span:last-child {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/RollingPlant.vue